export { default, Props as LayoutRouteProps } from "./LayoutRoute";



// WEBPACK FOOTER //
// ./src/components/LayoutRoute/index.ts